import { useMutation } from '@tanstack/react-query'
import { TypeSignupApplication } from './useSignUpApplication'
import { post, queryKeys, SignUpUrl } from '@mobi/account/Utils'

export type TypeVerificationResponse = {
  enquiryId: string
  potentialSanctionedMatch: boolean
  potentialFraudMatch: boolean
  isVerified: boolean
  unVerifiedReason: string
}

export type TypeDriversLicenceDetailsRequest = TypeSignupApplication & {
  licenceDetails: {
    number: string
    state: string
    cardNumber: string
  }
}

export const useVerifyDriversLicence = () => {
  const { mutate: verifyDriversLicence, status: verifyDriversLicenceStatus } = useMutation({
    mutationFn: (
      driversLicenceDetails: TypeDriversLicenceDetailsRequest
    ): Promise<TypeVerificationResponse> =>
      post(SignUpUrl.verifyDriversLicence, driversLicenceDetails),
    mutationKey: [queryKeys.signupVerifyDriversLicence],
  })
  return { verifyDriversLicence, verifyDriversLicenceStatus }
}
